import { JSONSchema7Definition } from 'json-schema';

declare module 'json-schema' {
    export interface JSONSchema7 {
        enumNames?: Array<string | number>;
    }
}

export interface LayoutSchemaWidgetProperties {
    width?: string;
    height?: string;
    margin?: string;
    padding?: string;
    display?: string;
    flexGrow?: string;
    flexDirection?: string;
    alignItemsHorizontal?: string;
    alignItemsVertical?: string;
}

export interface LayoutSchemaProperties {
    width: string;
    height: string;
    margin: string;
    padding: string;
    display: string;
    'flex-grow': string;
    'flex-direction': string;
    'justify-content': string;
    'align-items': string;
}

interface Schema {
    [key: string]: JSONSchema7Definition;
}

const schema: Schema = {
    width: {
        type: 'string',
        title: 'Width',
        default: '',
    },
    height: {
        type: 'string',
        title: 'Height',
        default: '',
    },
    // related css property-> margin: value(All sides) ||
    // margin: value(top) value(right) value(bottom) value(left);
    margin: {
        type: 'string',
        title: 'Margin',
        default: '',
    },
    // related css property-> padding: value(All sides) ||
    // padding: value(top) value(right) value(bottom) value(left);
    padding: {
        type: 'string',
        title: 'Padding',
        default: '',
    },
    // related css property-> displau: value;
    display: {
        type: 'string',
        title: 'Display',
        default: '',
        enum: ['', 'inline', 'block', 'inline-block', 'flex'],
    },
};

const dependencies: Schema = {
    display: {
        oneOf: [
            {
                properties: {
                    display: { enum: ['flex'] },
                    flexGrow: {
                        type: 'string',
                        title: 'Fill Space',
                        default: '',
                    },
                    flexDirection: {
                        type: 'string',
                        title: 'Flex Direction',
                        default: '',
                    },
                    alignItemsHorizontal: {
                        type: 'string',
                        title: 'Alignment',
                        default: '',
                    },
                    alignItemsVertical: {
                        type: 'string',
                        title: '',
                        default: '',
                    },
                },
            },
        ],
    },
};

const group = {
    Layout: [
        'width',
        'height',
        'margin',
        'padding',
        'display',
        'flexGrow',
        'flexDirection',
        'alignItemsHorizontal',
        'alignItemsVertical',
    ],
};

const uiSchema = {
    width: { 'ui:widget': 'WidthModelProperties' },
    height: { 'ui:widget': 'WidthModelProperties' },
    margin: { 'ui:widget': 'BoxModelProperties' },
    padding: { 'ui:widget': 'BoxModelProperties' },
    display: { 'ui:widget': 'DisplayOption' },
    flexGrow: { 'ui:widget': 'FillSpaceProperty' },
    flexDirection: { 'ui:widget': 'FlexDirectionProperty' },
    alignItemsHorizontal: { 'ui:widget': 'ItemHorizontalAlign' },
    alignItemsVertical: { 'ui:widget': 'ItemVerticalAlign' },
};

export const LayoutSchema = {
    schema,
    group,
    uiSchema,
    dependencies,
};
